import {useTranslation} from 'react-i18next'
import React, {FunctionComponent} from 'react'
import ManagePeriod from './ManagePeriod/ManagePeriod'
import Spinner from '../../../App/Components/Spinner/Spinner'
import {IProps} from './IProps'

const Manage: FunctionComponent<IProps> = ({targets}) =>{
    const [t] = useTranslation()

    if (null === targets) {
        return <Spinner/>
    }

    return (
        <div className={'page-layout large'}>
            <a href="/hr/targets/overview" className="button margin-bottom-large">{t('Overview')}</a>
            <h1>{t('Targets management')}</h1>
            <div>
                <ol>
                    <ManagePeriod
                        period={'daily'}
                        targets={targets}
                    />
                    <ManagePeriod
                        period={'weekly'}
                        targets={targets}
                    />
                    <ManagePeriod
                        period={'monthly'}
                        targets={targets}
                    />
                    <ManagePeriod
                        period={'yearly'}
                        targets={targets}
                    />
                </ol>
            </div>
            <a className="button" href="/hr/targets/manage/add">{t('Add target')}</a>
        </div>
    )
}

export default Manage
